import { alpha } from '@mui/material/styles'

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			all: 'unset',
			position: 'absolute',
			left: -2,
			right: -2,
			bottom: -2,
			top: '50%',
			height: 'calc(100% + 4px)',
			minHeight: 44,
			transform: 'translateY(-50%)',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			backgroundColor: alpha('#D8D8D8', 0.5),
			color: theme.palette.scoreapp.primary,
			zIndex: 1000,
			cursor: 'pointer',
			fontSize: 14,
			fontFamily: 'Instrument Sans',
			fontWeight: 500,
		},
		content: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			backgroundColor: theme.palette.common.white,
			border: `1px solid ${theme.palette.scoreapp.primary}`,
			minHeight: 30,
			padding: '4px 24px',
			borderRadius: 3,
		},
		icon: {
			marginRight: 10,
			width: '1.2em',
			height: '1.2em',
			marginTop: '-0.25em',
		},
	}),
	{ name: 'Form-SettingsButton' },
)

export default useStyles
